const Thinker = {

    thinking: function (size) {
        if (!size) {
            size = 'chart';
        }
        return `<div class="thinker thinking-${size}">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve">
                    <g class="aero-anim">
                        <polygon style="fill:#00B6D0;" points="880.6,143.4 143.4,408.6 286,551.2"/>
                        <polyline style="fill:#00B6D0;" points="472.8,738 880.6,143.4 615.4,880.6"/>
                        <polygon style="fill:#008E90;" points="880.6,143.4 284,740 286,551.2"/>
                        <polyline style="fill:#006665;" points="472.8,738 880.6,143.4 284,740"/>
                    </g>
                </svg>
            </div>`;
    },

    /**
     * @param func
     * @param parent
     * @param size
     * @returns {Promise<void>}
     */
    think: async function (func, parent, size) {
        this.begin(parent, size);
        await func();
        this.end(parent);
    },

    begin: function (parent, size) {
        parent.append(this.thinking(size));
        parent.find('.thinker').animate({opacity: 0.95}, 200);
    },

    end: function (parent) {
        parent.find('.thinker').animate({opacity: 0}, 200).remove();
    }
};

export default Thinker;

